import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IframeScrollService {
  $scrollEvent = new Subject<any>();

  constructor() {}

  updateScrollEvent(event) {
    this.$scrollEvent.next(event);
  }
}
